import { showSuccess } from '@calendly/alert';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLazyFetchEligibilityQuery, useSubmitRequestToJoinMutation } from './api';
import { seatRequestBannerOpenedFromSelector, seatRequestOrganizationSelector } from './selectors';
import { closeSeatRequestModal, setToOrgListStep } from './slice';
import { ModalTitle } from './styles';
import { TRACKING_EVENT_NAMES, useTrack } from '../../hooks/analytics_events';
const subtitleCss = "sonbgw7";
const Subtitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'h3';
  return <Component ref={ref} {...restProps} className={classNames(subtitleCss, props.className)} />;
});
const textWrapperCss = "tg10j58";
const TextWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(textWrapperCss, props.className)} />;
});
export const SubmitStep = () => {
  const organization = useSelector(seatRequestOrganizationSelector);
  const dispatch = useDispatch();
  const [submitApiCall, {
    isError,
    isLoading: isSubmitting,
    isSuccess
  }] = useSubmitRequestToJoinMutation();
  const [refetchEligibility] = useLazyFetchEligibilityQuery();
  const track = useTrack();
  const openedFrom = useSelector(seatRequestBannerOpenedFromSelector);
  useEffect(() => {
    if (isSuccess) {
      dispatch(showSuccess(I18n.t('publisher.growth_experiments.seat_requests.request_modal.submit_step.success_toast', {
        owner_email: organization.ownerEmail
      })));
      dispatch(closeSeatRequestModal());
      refetchEligibility(); // run this so SeatRequestsBanner sees new request and stops showing
    }
    if (isError) {
      // No need to show error toast, we automatically show it
      dispatch(closeSeatRequestModal());
    }
  }, [dispatch, isError, isSuccess, organization, refetchEligibility]);
  const handleSubmit = () => {
    track({
      name: TRACKING_EVENT_NAMES.ORGANIZATION_MEMBERSHIP_REQUESTED,
      properties: {
        request_experience: 'scheduling_page_join_existing_org_modal',
        requesting_membership_organization_uuid: organization.orgUuid
      }
    });
    track({
      name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
      properties: {
        action: 'send_email',
        modal_name: 'connect_with_existing_org',
        modal_details: 'send_an_email_request',
        location: openedFrom,
        path: window.location.pathname
      }
    });
    submitApiCall(organization.orgUuid);
  };
  return <>
      <ModalTitle>
        {I18n.t('publisher.growth_experiments.seat_requests.request_modal.submit_step.title', {
        name: organization.ownerName
      })}
      </ModalTitle>
      <Subtitle>
        {I18n.t('publisher.growth_experiments.seat_requests.request_modal.submit_step.subtitle', {
        owner_email: organization.ownerEmail
      })}
      </Subtitle>
      <Button decoration="secondary-outline" disabled={isSubmitting} size="small" onClick={() => dispatch(setToOrgListStep())}>
        {I18n.t('publisher.growth_experiments.seat_requests.request_modal.submit_step.back_button')}
      </Button>
      <TextWrapper>
        <BodyText>
          {HtmlParser(I18n.t('publisher.growth_experiments.seat_requests.request_modal.submit_step.description'))}
        </BodyText>
      </TextWrapper>
      <Button loading={isSubmitting} onClick={handleSubmit} wide>
        {I18n.t('publisher.growth_experiments.seat_requests.request_modal.submit_step.cta')}
      </Button>
    </>;
};

require("./submit_step.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./submit_step.js");